<style>
  .bm-view {
    height: 300px;
    width: 350px;
  }

</style>
<template>
  <div class="detailMain">
    <div class="returnBtn" @click="goBack()">
      <i class="el-icon-back"></i>
    </div>
    <el-breadcrumb class="crumbs" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item v-for="(item,index)  in routeList" :key="index"
        :to="{ name: item.name,query:{id:item.query.id,flag:item.query.flag,name:item.query.name} }">
        {{item.name}}
      </el-breadcrumb-item>
    </el-breadcrumb>
    <el-card shadow="never">
      <div class="cardTop">
        <h1>{{ detailData.name }}</h1>
        <h2>
          <i v-if="detailData.onlineStatus == 0" class="redDot"></i>
          <i v-if="detailData.onlineStatus == 1" class="greenDot"></i>
          {{
          detailData.onlineStatus == 0
          ? "离线"
          : detailData.onlineStatus == 1
          ? "在线"
          : "---"
          }}
        </h2>
        <el-dropdown @command="handleCommand">
          <span class="el-dropdown-link">
            操作<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="edit">编辑</el-dropdown-item>
            <el-dropdown-item command="del">删除</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="cardBottom">
        <el-tabs tab-position="left" style="height: 520px;" @tab-click="handleTabClick">
          <el-tab-pane label="详情">
            <h1>设备详情</h1>
            <el-row class="formRow">
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <label>编号</label> <br />
                  <span>{{ detailData.code }}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <label>设备分类</label> <br />
                  <span>{{
                    detailData.categoryFullName != null
                      ? detailData.categoryFullName
                      : "---"
                  }}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <label>品牌</label> <br />
                  <span>{{
                    detailData.brandName != null ? detailData.brandName : "---"
                  }}</span>
                </div>
              </el-col>
              <!-- <el-col :span="12">
                <div class="grid-content bg-purple">
                  <label>型号</label> <br />
                  <span>{{
                    detailData.modelName != null ? detailData.modelName : "---"
                  }}</span>
                </div>
              </el-col> -->
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <label>连接网关</label> <br />
                  <span>{{
                    detailData.mduModuleObj != null
                      ? detailData.mduModuleObj
                      : "---"
                  }}</span>
                </div>
              </el-col>
              <!-- <el-col :span="12">
                <div class="grid-content bg-purple">
                  <label>连接方式</label> <br />
                  <span>{{
                    detailData.linkTypeObj != null
                      ? detailData.linkTypeObj
                      : "---"
                  }}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <label>操作系统</label> <br />
                  <span>{{
                    detailData.osObj != null ? detailData.osObj : "---"
                  }}</span>
                </div>
              </el-col> -->
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <label>采集频率</label> <br />
                  <span>{{detailData.collectCron != null && detailData.collectCron != '' ? detailData.collectCron : '---'}}</span>
                </div>
              </el-col>
              <el-col :span="24">
                <div class="grid-content bg-purple">
                  <label>第三方平台参数</label> <br />
                  <pre>{{
                    detailData.devOptions != null && detailData.devOptions.trim() != "" ? JSON.stringify(JSON.parse(detailData.devOptions),null,2) : "---"
                  }}</pre>
                </div>
              </el-col>
              <el-col :span="24">
                <div class="grid-content bg-purple">
                  <label>备注</label> <br />
                  <span>{{
              detailData.remarks != null ? detailData.remarks : ""
              }}</span>
                </div>
              </el-col>
            </el-row>
            <h1 style="margin-top:30px">系统信息</h1>
            <el-row class="formRow">
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <label>创建人</label> <br />
                  <span>{{
                    detailData.creator != null ? detailData.creator : "---"
                  }}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <label>创建时间</label> <br />
                  <span>{{
                    detailData.createDate != null
                      ? changeDate(detailData.createDate)
                      : "---"
                  }}</span>
                </div>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="协议" class="protocol">
            <h1>设备协议</h1>
            <el-row :gutter="15" class="formRow">
              <el-col :span="8" v-if="agreementShow">
                <div @click="jumpDetail(agreement.id)">
                  <el-card shadow="hover">
                    <label>{{ agreement.name }}</label> <br />
                    <span>{{
                      agreement.type == 1
                        ? "平台协议"
                        : agreement.type == 2
                        ? "私有协议"
                        : "---"
                    }}</span>
                  </el-card>
                </div>
              </el-col>
              <p style="line-height:50px;margin-left:20px;" v-if="!agreementShow">
                {{ agreementTips }}
              </p>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="地理位置">
            <h1 style="margin-top:30px">设备定位</h1>
            <el-row class="formRow">
              <el-col :span="12">
                <el-col :span="24">
                  <div class="grid-content bg-purple">
                    <label>GIS（纬度，经度）</label> <br />
                    <span>{{detailData.latitude}},{{detailData.longitude}}</span>
                  </div>
                </el-col>
                <el-col :span="24">
                  <div class="grid-content bg-purple">
                    <label>设备点位</label> <br />
                    <span>{{detailData.location}}</span>
                  </div>
                </el-col>
              </el-col>
              <el-col :span="12">
                <div v-if="mapShow">
                  <baidu-map class="bm-view" :center="center" :zoom="10" :scroll-wheel-zoom="true">
                    <bm-marker v-if="position" :position="position" :dragging="true">
                    </bm-marker>
                  </baidu-map>
                </div>

              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="远程控制">
            <remote-control :deviceId="ids" :deviceCode="code"></remote-control>
          </el-tab-pane>
          <el-tab-pane label="设备数据">
            <device-data-show :deviceId="ids"></device-data-show>
          </el-tab-pane>
          <!-- <el-tab-pane label="日志">日志</el-tab-pane> -->
        </el-tabs>
      </div>
    </el-card>

  </div>
</template>
<script>
  import API from "../../api/api";
  import dayjs from "dayjs";
  import remoteControl from '@/components/device/remoteControl.vue' //引入远程控制子组件
  import deviceDataShow from '@/components/device/deviceDataShow.vue' //引入数据展示子组件
  export default {
    components: {
      remoteControl,
      deviceDataShow
    },
    data() {
      return {
        ids: this.$route.query.id,
        routeList: this.$route.meta.routeList,
        code: "", //设备的code
        BooleanType: [{
            label: true,
            value: true
          },
          {
            label: false,
            value: false
          }
        ],
        //  dayjs(new Date().getTime() - 3600 * 1000 * 24 * 7).format("YYYY-MM-DD HH:mm"), 一周前
        //  dayjs(new Date()).format("YYYY-MM-DD HH:mm")当前
        start: dayjs(
          new Date(new Date(new Date(new Date().toLocaleDateString()).getTime()))
        ).format("YYYY-MM-DD HH:mm"), //当天的00点
        end: dayjs(
          new Date(
            new Date(new Date().toLocaleDateString()).getTime() +
            24 * 60 * 60 * 1000 -
            1
          )
        ).format("YYYY-MM-DD HH:mm"), //当天的23.59.59点
        detailData: {}, //详情数据
        realTimeData: [], //物影子-实时数据
        activeName: "first",
        historicalDatadialog: false, //历史数据
        chart: null,
        agreement: {}, //协议
        agreementShow: false,
        agreementTips: "",
        position: null,
        center: '广州市',
        mapShow: false
      };
    },
    created() {},
    methods: {

      handleTabClick(a) {
        if (a.label === '地理位置') {
          this.mapShow = true
        } else if (a.label === '设备数据') {
          // this.$router.push({
          //   path: "/equipment/equipmentViewData",
          //   query: {
          //     id: this.ids,
          //     name: this.detailData.name
          //   }
          // });
        }
      },

      //获取设备详情
      getPlatformDevDeviceView() {
        API.platformDevDeviceView(this.ids).then(res => {
          if (res.code == 1) {
            this.detailData = res.data;
            if (res.data.longitude && res.data.latitude) {
              var point = {
                lng: res.data.longitude,
                lat: res.data.latitude
              }
              this.position = point
              this.center = point
            }
            this.code = res.data.code;
            //根据设备协议查找协议
            API.platformDevProtocolView(res.data.devProtocolId).then(res => {
              if (res.code == 1) {
                this.agreement = res.data;
                this.agreementShow = true;
              } else {
                this.agreementShow = false;
                this.agreementTips = res.msg;
              }
            });
          }
        });
        //物影子数据
        // API.platformDevDeviceGetrealtimedata({
        //   id: this.ids
        // }).then(res => {
        //   if (res.code == 1) {
        //     this.realTimeData = res.data;
        //   }
        // });
        //根据设备查找远程控制
        API.platformDevDeviceTelecontrol(this.ids).then(res => {
          if (res.code == 1) {
            this.telecontrolData = res.data;
          }
        });
      },

      //跳转协议详情
      jumpDetail(id) {
        this.$router.push({
          path: "/equipment/equimentProtocolDetails",
          query: {
            id: id
          }
        });
      },
      //执行按钮
      executeBtn(row) {
        //把数据放到executeObj里
        this.executeObj = row;
        this.executeForm.packetCode = row.packetCode;
        this.executeDialog = true;
        API.platformDevDevicePackFeilds({
          id: row.id
        }).then(res => {
          if (res.code == 1) {
            this.executeForm.params = res.data;
          }
        });
      },

      //操作下拉
      handleCommand(para) {
        if (para == "edit") {
          //编辑
          this.$router.push({
            path: "/equipment/equipmentAdd",
            query: {
              id: this.ids,
              flag: "edit"
            }
          });
        } else if (para == "del") {
          //删除
          let para = {
            ids: this.ids
          };
          this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            })
            .then(() => {
              API.delPlatformDevDevice(para).then(res => {
                if (res.code == 1) {
                  this.$message.success("删除成功");
                  this.$router.push({
                    path: "/equipment/equipmentManagement"
                  });
                } else {
                  var falseList = res.data;
                  var errMsgStr;
                  falseList.forEach(errMsg => {
                    errMsgStr = errMsg.substring(errMsg.indexOf('删除失败'))
                    return;
                  })
                  this.$message.error(errMsgStr);
                }
              });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消删除"
              });
            });
        }
      },
      //初始化时间
      changeDate(time) {
        if (!time) return '';
        return dayjs(new Date(time)).format("YYYY-MM-DD HH:mm:ss");
      },
      //序列化数据类型
      getDataType(row) {
        switch (row.dataType) {
          case 1:
            return "数值类型";
            break;

          case 2:
            return "布尔类型";
            break;

          case 3:
            return "字符串";
            break;

          case 4:
            return "16进制";
            break;

          default:
            return "---";
        }
      }
    },
    mounted() {
      this.getPlatformDevDeviceView();
    }
  };

</script>



// WEBPACK FOOTER //
// src/views/platform/equipmentDetail.vue